import React, { useState } from 'react';
import axios from 'axios';

const OverrideModal = ({ application, onClose, onSuccess }) => {
  const [comments, setComments] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (approved) => {
    if (!comments.trim()) return;
    setSubmitting(true);
    setError('');

    try {
      await axios.post(`/api/applications/${application.id}/approve/override`, {
        approved,
        comments: comments.trim(),
      });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit override');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
      <div style={{ backgroundColor: 'var(--color-surface)', color: 'var(--color-text)', borderRadius: '8px', padding: '24px', maxWidth: '500px', width: '90%', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
        <h3 style={{ marginTop: 0 }}>Override Manager Approval</h3>
        <p><strong>Applicant:</strong> {application.User?.name || 'Unknown'}</p>
        <p><strong>Current Status:</strong> {
          !application.ManagerApproval || application.ManagerApproval.approved === null
            ? 'Pending'
            : application.ManagerApproval.approved ? 'Approved' : 'Rejected'
        }</p>

        <textarea
          placeholder="Enter a comment (required)..."
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          style={{ width: '100%', minHeight: '80px', padding: '8px', borderRadius: '4px', border: '1px solid var(--color-border-input)', resize: 'vertical', marginBottom: '12px', backgroundColor: 'var(--color-surface)', color: 'var(--color-text)' }}
          disabled={submitting}
        />

        {error && <p style={{ color: 'var(--color-danger-dk)', fontSize: '0.9em' }}>{error}</p>}

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={submitting}
            style={{ padding: '8px 16px', borderRadius: '4px', border: '1px solid var(--color-border-input)', background: 'var(--color-surface)', color: 'var(--color-text)', cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            onClick={() => handleSubmit(false)}
            disabled={!comments.trim() || submitting}
            style={{ padding: '8px 16px', borderRadius: '4px', border: 'none', backgroundColor: comments.trim() ? 'var(--color-danger-dk)' : 'var(--color-disabled)', color: '#fff', cursor: comments.trim() ? 'pointer' : 'not-allowed' }}
          >
            Reject
          </button>
          <button
            onClick={() => handleSubmit(true)}
            disabled={!comments.trim() || submitting}
            style={{ padding: '8px 16px', borderRadius: '4px', border: 'none', backgroundColor: comments.trim() ? 'var(--color-success)' : 'var(--color-disabled)', color: '#fff', cursor: comments.trim() ? 'pointer' : 'not-allowed' }}
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverrideModal;
